import { render, staticRenderFns } from "./WinnerEvalutionModal.vue?vue&type=template&id=0ea4116c&scoped=true"
import script from "./WinnerEvalutionModal.vue?vue&type=script&lang=js"
export * from "./WinnerEvalutionModal.vue?vue&type=script&lang=js"
import style0 from "./WinnerEvalutionModal.vue?vue&type=style&index=0&id=0ea4116c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea4116c",
  null
  
)

export default component.exports